import './MailToExecutor.scss';
import { IBaseAction } from '@models/actions/IBaseAction';
import { DocBaseActionExecutor } from '@organisms/actions/DocBaseActionExecutor';
import { FilesService } from '@services/FilesService';
import ActionConfirmationModal from '@organisms/actions/ActionConfirmationModal/ActionConfirmationModal';

export class MailToExecutor extends DocBaseActionExecutor {
    runInternal = (
        objId: string,
        _parentId: string | undefined,
        action: IBaseAction,
        _rowData?: any,
        completeHandler?: (isSucceed: boolean) => void,
    ) => {
        if (!action.options?.confirmation) {
            void this.download(action, objId);
            completeHandler && completeHandler(false);
        }
    };

    /** Отказ FilesService показывает тостом с причиной сам */
    private download(action: IBaseAction, objId: string): Promise<void> {
        return FilesService.downloadFile(`documentExecution/mailTo/${objId}/${action.key}`).catch(() => undefined);
    }

    visualElementInner = () => {
        return this._action?.options?.confirmation ? (
            <ActionConfirmationModal
                title={this._action.options.confirmation.title}
                message={this._action.options.confirmation.message}
                okButtonText={this._action.options.confirmation.okButtonText}
                cancelButtonText={this._action.options.confirmation.cancelButtonText}
                onOkClick={async () => {
                    if (!this._action) return;
                    // окно ждёт файл: «ОК» показывает ход, повтор и закрытие недоступны до ответа
                    await this.download(this._action, this._objId!);
                    this._completeHandler && this._completeHandler(false);
                }}
                onCancelClick={() => {
                    this._completeHandler && this._completeHandler(false);
                }}
            />
        ) : (
            <></>
        );
    };
}
